const PENDING = "PENDING";
const COMPLETED = "COMPLETED";
const ERROR = "ERROR";
const ACTIVE = "ACTIVE";

export { PENDING, COMPLETED, ERROR, ACTIVE };
